<template>
  <div>
    <!--  部门  -->
    <el-breadcrumb separator="/" class="top-div">
      <el-breadcrumb-item>数据统计</el-breadcrumb-item>
      <el-breadcrumb-item>部门商洽效率分析</el-breadcrumb-item>
    </el-breadcrumb>
    <el-divider></el-divider>
    <el-form ref="form" :model="serchForm" :inline="true" label-width="auto">
<!--      <el-form-item label="部门名称：" prop="proname">-->
<!--        <el-select v-model="serchForm.depart_id" placeholder="请选择部门查询后显示数据" style="width:300px">-->
<!--          <el-option-->
<!--            v-for="item in depData"-->
<!--            :key="item.id"-->
<!--            :label="item.department_name"-->
<!--            :value="item.id">-->
<!--          </el-option>-->
<!--        </el-select>-->
<!--      </el-form-item>-->
      <el-form-item label="项目签约日期：" prop="create_time">
        <el-date-picker
          v-model="serchForm.create_time"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width:300px"
          value-format="yyyy-MM-dd"
          placeholder="请选择日期">
        </el-date-picker>
      </el-form-item>

      <el-form-item style="margin-left: 40px">
        <el-button type="primary" class="btn-add" @click="getData"
                   style="margin-bottom:28px;background-color:rgb(133,206,97);border: rgb(133,206,97); box-shadow: 0px 3px 13px 0px rgba(133,206,97, 0.38);">
          查询
        </el-button>
        <!--        <el-button type="primary" class="btn-add" @click="clearData"-->
        <!--                   style="margin-bottom:28px;background-color:rgb(247,137,137);border: rgb(247,137,137); box-shadow: 0px 3px 13px 0px rgba(247,137,137, 0.38);margin-left: 40px">-->
        <!--          清空查询-->
        <!--        </el-button>-->
        <el-button type="primary" class="btn-add" @click="export_ex" style="margin-left: 40px">导出
        </el-button>
      </el-form-item>
    </el-form>


    <div v-if="showTab">
      <el-table
        v-loading="loading"
        :data="tableData"
        border
        :header-cell-style="{ background: '#f6f9ff',color:'#7c8db5'}" :cell-style="{color:'#25396f'}">
        <el-table-column
          prop="department_name"
          align="center"
          label="部门名称">
        </el-table-column>
        <el-table-column
          prop="cost"
          label="固定成本"
          align="center"
          width="180">
          <template slot-scope="scope">
            {{parseFloat(scope.row.cost).toFixed(2)}}
          </template>
        </el-table-column>

        <el-table-column
          prop="count"
          align="center"
          label="人数">
        </el-table-column>
        <el-table-column
          prop="contract_amount"
          align="center"
          label="合同金额（万元）">
        </el-table-column>
        <el-table-column
          prop="contract_amount_avg"
          align="center"
          label="人均合同金额（万元）">
          <template slot-scope="scope">
            {{parseFloat(scope.row.contract_amount_avg).toFixed(2)}}
          </template>
        </el-table-column>
        <el-table-column
          prop="amount_received"
          align="center"
          label="已回款金额（万元）">
          <template slot-scope="scope">
            {{parseFloat(scope.row.amount_received).toFixed(2)}}
          </template>
        </el-table-column>
        <el-table-column
          prop="amount_received_avg"
          align="center"
          label="人均回款金额（万元）">
          <template slot-scope="scope">
            {{parseFloat(scope.row.amount_received_avg).toFixed(2)}}
          </template>
        </el-table-column>
        <el-table-column
          prop="billing_amount"
          align="center"
          label="已开票金额（万元）">
          <template slot-scope="scope">
            {{parseFloat(scope.row.billing_amount).toFixed(2)}}
          </template>
        </el-table-column>
        <el-table-column
          prop="capital_inventory"
          align="center"
          label="库存资金（万元）">
          <template slot-scope="scope">
            {{parseFloat(scope.row.capital_inventory).toFixed(2)}}
          </template>
        </el-table-column>
        <el-table-column
          prop="capital_inventory_support"
          align="center"
          label="库存资金支持">
          <template slot-scope="scope">
            {{parseFloat(scope.row.capital_inventory_support).toFixed(2)}}
          </template>
        </el-table-column>
        <el-table-column
          prop="cash_flow_support"
          align="center"
          label="现金流支持">
          <template slot-scope="scope">
            {{parseFloat(scope.row.cash_flow_support).toFixed(2)}}
          </template>
        </el-table-column>
      </el-table>

            <Pagination
              v-if="total > 0"
              :currentPage="currentPage"
              :total="total"
              :limit="limit"
              @handleCurrentChange="handleCurrentChange">
            </Pagination>

    </div>  </div>
</template>

<script>
import {get_departments,  efficiency,getefficiency} from '../../api/user'
import Pagination from "../../components/Pagination";

export default {
  // 注册组件
  components: {
    Pagination
  },
  data(){
    return{
      loading:false,
      showTab:false,
      serchForm:{
        depart_id:'',
        create_time:''
      },
      serchRules:[],
      depData:[],

      tableData:[],
      //合计
      num:'',
      department_name:'',
      depart_id:'',
      total:'',
      limit:10,
      currentPage:1,
    //  是否查询过
      isSerch:false
    }
  },
  methods:{
    // changeName(val){
    //   for (let i = 0; i < this.depData.length; i++) {
    //     if(val == this.depData[i].id){
    //       this.department_name = this.depData[i].department_name
    //     }
    //   }
    // },

    //导出
    export_ex(){
      if(this.isSerch) {
        if(this.serchForm.create_time == '') {
          window.open('/api/efficiency?' + 'export_excel=1', '_blank');
        }else{
          window.open('/api/efficiency?' + 'export_excel=1&create_time='+this.serchForm.create_time, '_blank');
s        }
      }else{
        this.$message.error('请查询后再导出！')
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getData()
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex === 0) {
          return {
            rowspan: this.tableData.length,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    //获取所有数据
    getData(){
      this.loading = true
      let paramas = {
        // department_id:this.serchForm.depart_id,
        create_time:this.serchForm.create_time,
        page:this.currentPage,
        limit:10,
        // export_excel:1
      }
      efficiency(paramas).then(res =>{
        if(res.code == 200){
          this.showTab = true
          this.tableData = res.data
          this.total = res.total
          this.loading = false
          this.isSerch = true
        }else {
          this.$message.error(res.msg)
        }
      })
    },


    //获取部门
    getDept() {
      let params = {
        token: localStorage.getItem("token"),
        // page: this.currentPage,
        // limit:10
      }
      get_departments(params).then(res => {
        if (res.code === 200) {
          this.depData = res.data;
          // this.limit = res.limit;
          // this.total = res.total;
        } else {
          this.$message.error(res.msg)
        }
      })
    },

  },
  mounted(){
    this.isSerch = false
    this.getDept()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/statement/sales.vue